// extracted by css-extract-rspack-plugin
var _1 = "PxpHpsL53MgzDzPQ";
var _2 = "PxpHpsL53MgzDzPQ";
var _3 = "h3uDTEPpcKIcMzyi";
var _4 = "owwAt72CnYWwh7cR";
var _5 = "h3uDTEPpcKIcMzyi";
var _6 = "owwAt72CnYWwh7cR";
export { _1 as "buttons-wrapper", _2 as "buttonsWrapper", _3 as "title--sticky", _4 as "title--with-buttons", _5 as "titleSticky", _6 as "titleWithButtons" }
